// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__kFXgP","form__search":"styles_form__search__BejQx","form__filters":"styles_form__filters__t0A2c","pulse":"styles_pulse___hzH7","jump":"styles_jump__x7XAz"};